<template>
    <div class="w-100">
        <section>
            <div class="container">
                <div class="status-table-container">
                    <section class="container">
                        <div class="row">
                            <StatusTile v-for="monitor in monitors" :monitor="monitor" />
                        </div>
                    </section>
                    <PastIncidents :monitors="monitors" v-if="monitors" />
                </div>
            </div>
        </section>
    </div>
</template>

<script>
import ApiRequest from '@js/utilities/apiRequest.js'
import { useStore } from 'vuex'

// lodash components
import map from 'lodash/map'

export default {
    setup() {
        const store = useStore()
        return {
            store,
        }
    },
    data() {
        return {
            monitors: null,
        }
    },
    mounted: function () {
        this.getMontiors()
    },
    methods: {
        getMontiors: function () {
            ApiRequest.get(this.$store, this.url(`/api/v2/status/uptime/summary`), {
                monitors: map(this.pageData.monitors, monitor => monitor.monitor_id),
            }).then(data => {
                this.monitors = data
                this.store.commit('saveMonitors', data)
            })
        },
    },
    computed: {
        pageData: function () {
            if (this.store.state.global.page) {
                this.emitter.emit('pageData:loaded')
                return this.store.state.global.page
            }
            return null
        },
    },
}
</script>

<style lang="scss">
@import '~scss/mixins/rem';
@import '~scss/settings/responsive';

.status-table-container {
    margin: rem(40px) auto;
    max-width: rem(970px);

    @media screen and (min-width: $bp-large) {
        margin: rem(100px) auto;
    }
}
.outage {
    svg {
        margin-right: 10px;

        &.warning {
            color: #ffab00;
        }

        &.critical {
            color: #c44031;
        }
    }

    .time {
        font-size: 0.5rem;
        color: #255ed6;
        text-decoration-style: dotted;
    }
}
</style>
